var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadorderIconsmain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.186 0.752998V4.349C11.186 4.836 11.38 5.304 11.726 5.649C12.0729 5.99437 12.5425 6.18819 13.032 6.188H17.157",
    stroke: "#5070DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.568V15.136C17.2301 15.6964 17.0996 16.2474 16.8658 16.7571C16.6321 17.2669 16.2997 17.7253 15.888 18.106C15.4759 18.4885 14.9925 18.786 14.4654 18.9816C13.9383 19.1772 13.3778 19.2671 12.816 19.246H5.226C4.66074 19.2718 4.09594 19.1858 3.56398 18.993C3.03201 18.8001 2.54335 18.5041 2.126 18.122C1.71027 17.7403 1.37454 17.2797 1.13833 16.7671C0.90211 16.2545 0.770111 15.7001 0.75 15.136V4.862C0.769854 4.30157 0.900422 3.75062 1.13418 3.24088C1.36794 2.73115 1.70026 2.27271 2.112 1.892C2.52408 1.50952 3.00748 1.21198 3.53458 1.01637C4.06169 0.82077 4.62217 0.730933 5.184 0.751998H10.898C11.7703 0.748917 12.6123 1.07166 13.259 1.657L16.219 4.379C16.5349 4.65108 16.7899 4.9866 16.9675 5.36374C17.1452 5.74089 17.2414 6.1512 17.25 6.568Z",
    stroke: "#5070DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.499V15.273",
    stroke: "#5070DE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.106 11.35L9.44104 8.685C9.38338 8.62664 9.31471 8.58031 9.23901 8.54869C9.1633 8.51707 9.08208 8.50079 9.00004 8.50079C8.918 8.50079 8.83678 8.51707 8.76108 8.54869C8.68538 8.58031 8.61671 8.62664 8.55904 8.685L5.89404 11.351",
    stroke: "#5070DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadorderIconsmain);
export default __webpack_public_path__ + "static/media/uploadorderIconsmain.9169eca806ac465fe5aa678f8d741927.svg";
export { ForwardRef as ReactComponent };